<ion-header>
  <ion-toolbar color="light">
    <ion-title>Page Not Found</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <h1>404 – We couldn't find that page</h1>

  <p>Sorry, the page you are looking for does not exist.</p>

  <div style="margin: 2rem 0">
    <ion-chip color="danger">
      <ion-icon name="alert-outline"></ion-icon>
      <ion-label>/{{ unknownPath }}</ion-label>
    </ion-chip>
  </div>

  <!-- <ion-button expand="block" [routerLink]="homeRoute">
    Go Home
    <ion-icon slot="start" name="home-outline"></ion-icon>
  </ion-button>  -->

  <!-- <ion-button expand="block" routerLink="/folder/inbox">
    Go Home2
    <ion-icon slot="start" name="home-outline"></ion-icon>
  </ion-button>  -->

  <ion-button expand="block" routerLink="/">
    Go Home
    <ion-icon slot="start" name="home-outline"></ion-icon>
  </ion-button>
</ion-content>
